<template>
  <div class="row">
    <div class="col-sm-3 col-md-offset-1">
        <label id="select-payment">
          {{computeCaption(fields_en['select_payment_type'], $store.state.lang.value.toLowerCase())}}
        </label>
    </div>
    <div class="col-sm-7">
      <div class="form-group gender-float">
        <el-radio-group
          v-model="selectedBill"
          size="small"
        >
          <el-radio-button
            tabindex="0"
            v-for="(bill, index) in filterBills"
            v-if="bill.visible"
            :key="bill['name'] + index"
            :value="bill"
            inline
            :label="bill"
          >{{computeCaption(bill['name'], $store.state.lang.value.toLowerCase())}}</el-radio-button
          >
        </el-radio-group>
      </div>
    </div>
    <Bill ref="Bill" :bill="selectedBill" v-if="selectedBill" @validateBill="validateBill"
          @validateSignature="validateSignature" @validateQuestion="validateQuestion"/>

  </div>
</template>

<script>
import {Col, Row, Input, Button, RadioGroup, Radio, RadioButton} from 'element-ui'
import {TranslationsUtils} from '../../../../../../utils/Translations'
import {AccessionUtils} from '../../../../../../utils/AccessionDetailsProcessing'
import {SettingsUtils} from '../../../../../../utils/SiteConfigurations'
import {LayoutCalculationUtils} from '../../../../../../utils/LayoutCalculation'
import {FormatterUtils} from '../../../../../../utils/Formatter'
import {QuestionUtils} from '../../../../../../utils/Questions'
import Bill from './Bill'
export default {
  name: 'BillSelector',
  props: ['billsArray', 'restrictInsuranceByIcd', 'icdCodes', 'allowPayment'],
  components: {
    Bill,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [RadioButton.name]: RadioButton,
    [Input.name]: Input,
    [Button.name]: Button,
    [Row.name]: Row,
    [Col.name]: Col
  },
  mixins: [
    TranslationsUtils,
    AccessionUtils,
    SettingsUtils,
    LayoutCalculationUtils,
    FormatterUtils,
    QuestionUtils
  ],
  data () {
    return {
      allBills: [],
      submit: false,
      componentValidation: {
        paymentValidation: false,
        disclaimerValidation: false,
        questionsValidation: false
      },
      singlePage: this.$store.state.configs.SINGLE_PAGE_ORDERS || '',
      hideInsurance: false,
      selectedBill: {
        name: '',
        visible: false,
        type: '',
        disclaimer: '',
        signature: false,
        sorter: ''
      },
      fields_en: {
        'select_payment_type': 'Select Payment Type'
      }
    }
  },
  methods: {
    async validate () {
      this.submit = true
      let model = await this.$refs.Bill.validate()
      model.insurance_pay = this.selectedBill.type
      model.selectedBill = this.selectedBill.name
      return model
    },
    validateBill (booleanValue) {
      this.componentValidation.paymentValidation = booleanValue
    },
    validateSignature (booleanValue) {
      this.componentValidation.disclaimerValidation = booleanValue
    },
    validateQuestion (booleanValue) {
      this.componentValidation.questionsValidation = booleanValue
    }
  },
  async beforeMount () {
    let token = localStorage.getItem('token')
    if (this.singlePage === true || token) {
      let vue = this
      this.$store.state.calculations.map((calc) => {
        if (calc['name'] === 'Patient Portal Bill Calculation' && vue) {
          // eslint-disable-next-line no-eval
          eval(calc['code'])
        }
      })
    }
  },
  mounted () {
    this.selectedBill = this.filterBills.find(bill => bill.visible)
  },
  computed: {
    filterBills () {
      let filteredArray = this.billsArray.map(bill => {
        if (bill.type === 'insurance') {
          if (this.hideInsurance) {
            return {...bill, visible: false}
          } else {
            return {...bill, visible: true}
          }
        }
        if (bill.type === 'cash') {
          if (!this.allowPayment) {
            return {...bill, visible: false}
          } else {
            return {...bill, visible: true}
          }
        }
        return bill
      })
      this.selectedBill = filteredArray.find(bill => bill.visible)
      return filteredArray
    }
  },
  watch: {
    'icdCodes': {
      handler: function (val, prev) {
        if (prev && prev.length === 0 && val.length && this.restrictInsuranceByIcd === true) {
          this.hideInsurance = false
        } else if (!val.length && this.restrictInsuranceByIcd === true) {
          this.hideInsurance = true
        }
      },
      immediate: true
    },
    'componentValidation': {
      handler: function (val) {
        if (Object.values(this.componentValidation).every(field => field === true)) {
          this.$emit('validateSection', true)
        } else {
          this.$emit('validateSection', false)
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../../../assets/sass/paper/variables';
#select-payment{
  padding: 0px !important;
  line-height: 29px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Utils/SubComponents/BillParts/BillSelector.vue